// ─── FIREBASE — NeurUp ────────────────────────────────────────────────────────
// Cole sua apiKey real na linha abaixo antes de rodar o projeto.

import { initializeApp } from "firebase/app";
import {
  getAuth, GoogleAuthProvider, signInWithPopup,
  signInWithEmailAndPassword, signOut, onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore, collection, doc, getDoc, setDoc, addDoc,
  updateDoc, deleteDoc, query, where, orderBy, limit,
  onSnapshot, serverTimestamp, increment, arrayUnion, arrayRemove,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAaLzIJ6LgFMOvEmzpmBo8d2Owh_DIyfWI",
  authDomain: "liberi-e377c.firebaseapp.com",
  databaseURL: "https://liberi-e377c-default-rtdb.firebaseio.com",
  projectId: "liberi-e377c",
  storageBucket: "liberi-e377c.firebasestorage.app",
  messagingSenderId: "304236275616",
  appId: "1:304236275616:web:3ecf402fe0b1a6e0a7e6c5",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// ─── EXPORTAÇÕES DIRETAS DO FIRESTORE ────────────────────────────────────────
export {
  collection, doc, getDoc, setDoc, addDoc, updateDoc, deleteDoc,
  query, where, orderBy, limit, onSnapshot, serverTimestamp,
  increment, arrayUnion, arrayRemove,
};

// ─── AUTH ─────────────────────────────────────────────────────────────────────
export const loginComGoogle = () => signInWithPopup(auth, googleProvider);
export const loginComEmail = (email, senha) => signInWithEmailAndPassword(auth, email, senha);
export const logout = () => signOut(auth);
export const ouvirAuth = (cb) => onAuthStateChanged(auth, cb);

// ─── PERFIL ───────────────────────────────────────────────────────────────────
export const buscarPerfil = async (uid) => {
  const snap = await getDoc(doc(db, "usuarios", uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};
export const salvarPerfil = (uid, dados) =>
  setDoc(doc(db, "usuarios", uid), dados, { merge: true });
export const apagarConta = async (uid) => {
  await deleteDoc(doc(db, "usuarios", uid));
  await auth.currentUser?.delete();
};

// ─── FEED GERAL ───────────────────────────────────────────────────────────────
export const ouvirFeed = (cb) => {
  const q = query(
    collection(db, "posts_gerais"),
    where("status", "==", "aprovado"),
    orderBy("data", "desc"),
    limit(30)
  );
  return onSnapshot(q, (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );
};
export const criarPost = (uid, autor, foto, texto) =>
  addDoc(collection(db, "posts_gerais"), {
    uid, autor, foto, texto, status: "aprovado",
    reacoes: { "❤️": 0, "🧠": 0, "⭐": 0 },
    data: serverTimestamp(),
  });
export const apagarPost = (postId) =>
  deleteDoc(doc(db, "posts_gerais", postId));
export const reagirPost = (postId, emoji) =>
  updateDoc(doc(db, "posts_gerais", postId), {
    [`reacoes.${emoji}`]: increment(1),
  });

// ─── CIRCUITO KIDS ────────────────────────────────────────────────────────────
export const ouvirCircuito = (paiUid, cb) => {
  const q = query(
    collection(db, "posts_circuito"),
    where("pai_uid", "==", paiUid),
    orderBy("data", "desc"),
    limit(20)
  );
  return onSnapshot(q, (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );
};
export const criarPostCircuito = (paiUid, autorUid, autorNome, texto) =>
  addDoc(collection(db, "posts_circuito"), {
    pai_uid: paiUid, autor: autorUid, autorNome, texto,
    status: "pendente", data: serverTimestamp(),
  });
export const aprovarPostCircuito = (postId) =>
  updateDoc(doc(db, "posts_circuito", postId), { status: "aprovado" });
export const apagarPostCircuito = (postId) =>
  deleteDoc(doc(db, "posts_circuito", postId));

// ─── COMUNIDADES ──────────────────────────────────────────────────────────────
export const ouvirComunidades = (cb) => {
  const q = query(
    collection(db, "comunidades")
  );
  
  return onSnapshot(q, (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );
};
export const criarComunidade = (adminUid, dados) =>
  addDoc(collection(db, "comunidades"), {
    ...dados, adminUid, membros: 0, data: serverTimestamp(),
  });

// Entra na comunidade
export const entrarComunidade = async (uid, comunidadeId, nome) => {
  await setDoc(doc(db, "membros_comunidade", `${uid}_${comunidadeId}`), {
    uid: uid,
    comunidadeId: comunidadeId,
    nome: nome || "",
    data: serverTimestamp(),
  });
};

// Sai da comunidade
export const sairComunidade = async (uid, comunidadeId) => {
  await deleteDoc(doc(db, "membros_comunidade", `${uid}_${comunidadeId}`));
};

// Verifica se é membro pelo perfil (sem query extra)
export const verificarMembrosPorPerfil = (perfil) => {
  return new Set(perfil?.comunidades || []);
};

// Mantida para compatibilidade
export const verificarMembro = async (uid, comunidadeId) => {
  const snap = await getDoc(doc(db, "membros_comunidade", `${uid}_${comunidadeId}`));
  return snap.exists();
};

// ─── TÓPICOS ──────────────────────────────────────────────────────────────────
export const ouvirTopicos = (comunidadeId, cb) => {
  const q = query(
    collection(db, "topicos"),
    where("comunidadeId", "==", comunidadeId),
    orderBy("data", "asc")
  );
  return onSnapshot(q, (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );
};
export const criarTopico = async (uid, comunidadeId, titulo, descricao) => {
  await addDoc(collection(db, "topicos"), {
    criadoPor: uid,
    nomeAutor: "",
    comunidadeId,
    titulo,
    descricao,
    status: "aprovado",
    data: serverTimestamp(),
  });
};

// ─── RECADOS ──────────────────────────────────────────────────────────────────
export const ouvirRecados = (uid, cb) => {
  const q = query(
    collection(db, "recados"),
    where("para", "==", uid),
    orderBy("data", "desc"),
    limit(20)
  );
  return onSnapshot(q, (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );
};
export const enviarRecado = (deUid, paraUid, mensagem) =>
  addDoc(collection(db, "recados"), {
    de: deUid, para: paraUid, mensagem, data: serverTimestamp(),
  });
export const apagarRecado = (recadoId) =>
  deleteDoc(doc(db, "recados", recadoId));

// ─── NEURA — limite diário ────────────────────────────────────────────────────
export const buscarUsoNeura = async (familiaId) => {
  const hoje = new Date().toISOString().split("T")[0];
  try {
    const snap = await getDoc(doc(db, "uso_neura", `${familiaId}_${hoje}`));
    return snap.exists() ? snap.data().interacoes : 0;
  } catch { return 0; }
};
export const registrarUsoNeura = async (familiaId) => {
  const hoje = new Date().toISOString().split("T")[0];
  const ref = doc(db, "uso_neura", `${familiaId}_${hoje}`);
  try {
    const snap = await getDoc(ref);
    if (snap.exists()) {
      await updateDoc(ref, { interacoes: increment(1) });
    } else {
      await setDoc(ref, { familiaId, data: hoje, interacoes: 1, limite: 10 });
    }
  } catch (e) { console.log("Erro Neura:", e); }
};

// ─── AMIZADES ─────────────────────────────────────────────────────────────────
export const solicitarAmizade = (uid1, uid2) =>
  addDoc(collection(db, "amizades_adultos"), {
    uid1, uid2, status: "pendente", data: serverTimestamp(),
  });
export const aceitarAmizade = (amizadeId) =>
  updateDoc(doc(db, "amizades_adultos", amizadeId), { status: "aceito" });
export const solicitarAmizadeKid = (uid1, uid2, paiUid1, paiUid2) =>
  addDoc(collection(db, "amizades_kids"), {
    uid1, uid2, paiUid1, paiUid2, status: "pendente", data: serverTimestamp(),
  });